import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import * as _ from 'lodash';

@Component({
  moduleId: module.id,
  selector: 'truncate-with-tooltip',
  templateUrl: 'truncate-with-tooltip.component.html',
  styleUrls: ['truncate-with-tooltip.component.scss'],
})
export class TruncateWithTooltipComponent implements OnChanges {
  @Input() innerHtml: any;
  @Input() placement: string = 'left';
  @Input() toBody: boolean = true;

  @ViewChild('tooltip', {static: false}) tooltip: TooltipDirective;
  @ViewChild('scrollWidthDetector', {static: false}) scrollWidthDetector: ElementRef;

  isTruncated: boolean = false;

  constructor(
    private elementRef: ElementRef,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    _.defer(() => {
      // for block elements
      if (this.elementRef.nativeElement.scrollWidth > 0
        && (this.elementRef.nativeElement.offsetWidth < this.elementRef.nativeElement.scrollWidth)) {
        this.isTruncated = true;
        this.ref.markForCheck();
      }
      // for inline elements
      if (this.elementRef.nativeElement.scrollWidth === 0
        && (this.elementRef.nativeElement.offsetWidth > this.scrollWidthDetector.nativeElement.scrollWidth)) {
        this.isTruncated = true;
        this.ref.markForCheck();
      }
    });
  }
}
